// Photography and modeling, blended into one stream. kind: 'photo' | 'model'.
const PHOTOS = [
  { kind: 'photo', src: '/photography/arc.JPG', alt: 'arc of light' },
  { kind: 'photo', src: '/photography/bee1.JPG', alt: 'busy bee' },
  { kind: 'model', src: 'https://i.ibb.co/fGxZD025/IMG-4052.jpg', alt: 'Modeling' },
  { kind: 'photo', src: '/photography/bird1.JPG', alt: 'happy bird' },
  { kind: 'photo', src: '/photography/blue1.JPG', alt: 'yellow moon' },
  { kind: 'photo', src: '/photography/IMG_0542.jpg', alt: 'Chefchaouen' },
  { kind: 'photo', src: '/photography/blue2.JPG', alt: 'blue hour' },
  { kind: 'photo', src: '/photography/end1.jpg', alt: 'the end of the world' },
  { kind: 'photo', src: '/photography/end2.jpg', alt: 'the end pt.2' },
  { kind: 'photo', src: '/photography/halfmoon.jpg', alt: 'half moon rising' },
  { kind: 'photo', src: '/photography/horizon.JPG', alt: 'expansive horizon' },
  { kind: 'model', src: 'https://i.ibb.co/DPrYMhRR/IMG-4057.jpg', alt: 'Modeling' },
  { kind: 'photo', src: '/photography/ufo1.JPG', alt: 'flying UFO' },
  { kind: 'photo', src: '/photography/ufo2.JPG', alt: 'mysterious UFO' },
  { kind: 'photo', src: '/photography/IMG_0822.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1062.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1228.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1231.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1569.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1636.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1650.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1709.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1776.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1792.JPG', alt: '' },
  { kind: 'model', src: 'https://i.ibb.co/YBjBxZL5/IMG-4054.jpg', alt: 'Modeling' },
  { kind: 'photo', src: '/photography/IMG_1816.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1875.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_1968.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2008.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2011.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2012.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2052.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2057.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2233.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2247_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2265_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2266_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2291_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2297_copy.JPG', alt: '' },
  { kind: 'model', src: 'https://i.ibb.co/5WCzvVJH/IMG-4053.jpg', alt: 'Modeling' },
  { kind: 'photo', src: '/photography/IMG_2314_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2318_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2320_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2343.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2346.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2363_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2376.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2378.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2401.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2402.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2416.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2421.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2423.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2434_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2437_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2440_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2474_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2477_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2484_copy.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2520.JPG', alt: '' },
  { kind: 'photo', src: '/photography/IMG_2523.JPG', alt: '' },
];

export default PHOTOS;
